export const projectDetails = [
  {
    checkbox: true,
    project_id: "Inv-001",
    project_name:"Office Management App",
    leader: "Anthony Lewis",
    leader_image: "assets/img/users/user-32.jpg",
    team_img_1: "assets/img/users/user-09.jpg",
    team_img_2: "assets/img/users/user-47.jpg",
    team_img_3: "assets/img/users/user-44.jpg",
    team_img_count: "+2",
    deadline:"12 Sep 2024",
    priority: "Low",
    status: "Active",
    key: "1"
  },
  {
    checkbox: true,
    project_id: "PRO-002",
    project_name:"Clinic Management ",
    leader: "Brian Villalobos",
    leader_image: "assets/img/users/user-09.jpg",
    team_img_1: "assets/img/users/user-17.jpg",
    team_img_2: "assets/img/users/user-08.jpg",
    team_img_3: "assets/img/users/user-18.jpg",
    team_img_count: "+3",
    deadline:"24 Oct 2024",
    priority: "Medium",
    status: "Active",
    key: "2"
  },
  {
    checkbox: true,
    project_id: "PRO-003",
    project_name:"Educational Platform",
    leader: "Harvey Smith",
    leader_image: "assets/img/users/user-01.jpg",
    team_img_1: "assets/img/users/user-21.jpg",
    team_img_2: "assets/img/users/user-22.jpg",
    team_img_3: "assets/img/users/user-33.jpg",
    team_img_count: "+1",
    deadline:"18 Feb 2024",
    priority: "High",
    status: "Active",
    key: "3"
  },
  {
    checkbox: true,
    project_id: "PRO-004",
    project_name:"Chat & Call  Mobile App",
    leader: "Stephan Peralt",
    leader_image: "assets/img/users/user-33.jpg",
    team_img_1: "assets/img/users/user-16.jpg",
    team_img_2: "assets/img/users/user-26.jpg",
    team_img_3: "assets/img/users/user-35.jpg",
    team_img_count: "+3",
    deadline:"17 Oct 2024 ",
    priority: "Low",
    status: "Active",
    key: "4"
  },
  {
    checkbox: true,
    project_id: "PRO-005",
    project_name:"Travel Planning Website",
    leader: "Doglas Martini",
    leader_image: "assets/img/users/user-34.jpg",
    team_img_1: "assets/img/users/user-16.jpg",
    team_img_2: "assets/img/users/user-36.jpg",
    team_img_3: "assets/img/users/user-10.jpg",
    team_img_count: "+4",
    deadline:"20 Jul 2024",
    priority: "High",
    status: "Active",
    key: "5"
  },
  {
    checkbox: true,
    project_id: "PRO-006",
    project_name:"Service Booking Software",
    leader: "Linda Ray",
    leader_image: "assets/img/users/user-02.jpg",
    team_img_1: "assets/img/users/user-11.jpg",
    team_img_2: "assets/img/users/user-19.jpg",
    team_img_3: "assets/img/users/user-20.jpg",
    team_img_count: "+5",
    deadline:"10 Apr 2024",
    priority: "Low",
    status: "Active",
    key: "6"
  },
  {
    checkbox: true,
    project_id: "PRO-007",
    project_name:" Hotel Booking App",
    leader: "Elliot Murray",
    leader_image: "assets/img/users/user-22.jpg",
    team_img_1: "assets/img/users/user-14.jpg",
    team_img_2: "assets/img/users/user-29.jpg",
    team_img_3: "assets/img/users/user-22.jpg",
    team_img_count: "+4",
    deadline:"29 Aug 2024",
    priority: "Medium",
    status: "Active",
    key: "7"
  },
  {
    checkbox: true,
    project_id: "PRO-008",
    project_name:" Car & Bike Rental Software",
    leader: "Rebecca Smtih",
    leader_image: "assets/img/users/user-36.jpg",
    team_img_1: "assets/img/users/user-08.jpg",
    team_img_2: "assets/img/users/user-38.jpg",
    team_img_3: "assets/img/users/user-42.jpg",
    team_img_count: "+2",
    deadline:"22 Feb 2024",
    priority: "Low",
    status: "Inactive",
    key: "8"
  },
  {
    checkbox: true,
    project_id: "PRO-009",
    project_name:"Food Order App",
    leader: "Connie Waters",
    leader_image: "assets/img/users/user-37.jpg",
    team_img_1: "assets/img/users/user-26.jpg",
    team_img_2: "assets/img/users/user-02.jpg",
    team_img_3: "assets/img/users/user-40.jpg",
    team_img_count: "+1",
    deadline:"03 Nov 2024",
    priority: "Medium",
    status: "Active",
    key: "9"
  },
  {
    checkbox: true,
    project_id: "PRO-010",
    project_name:"POS Admin Software",
    leader: "Lori Broaddus",
    leader_image: "assets/img/users/user-38.jpg",
    team_img_1: "assets/img/users/user-13.jpg",
    team_img_2: "assets/img/users/user-11.jpg",
    team_img_3: "assets/img/users/user-18.jpg",
    team_img_count: "+3",
    deadline:"17 Dec 2024",
    priority: "Low",
    status: "Active",
    key: "10"
  },

];
